import {
  FETCH_REPORT_SIGNATURE_REQUEST,
  FETCH_REPORT_SIGNATURE_SUCCESS,
  FETCH_REPORT_SIGNATURE_FAILURE,
  SAVE_REPORT_SIGNATURE_REQUEST,
  SAVE_REPORT_SIGNATURE_SUCCESS,
  SAVE_REPORT_SIGNATURE_FAILURE,
  DELETE_REPORT_SIGNATURE_REQUEST,
  DELETE_REPORT_SIGNATURE_SUCCESS,
  DELETE_REPORT_SIGNATURE_FAILURE,
} from '@actions/reportSignature'
import { LOADING, SUCCEEDED, ERROR, IDLE } from '@constants/fetchStatuses'

const initialState = {
  data: null,
  status: IDLE,
  errorMessage: null,
}

export default function reportSignature(state = initialState, action) {
  switch (action.type) {
    case FETCH_REPORT_SIGNATURE_REQUEST:
    case SAVE_REPORT_SIGNATURE_REQUEST:
    case DELETE_REPORT_SIGNATURE_REQUEST:
      return { ...state, status: LOADING, errorMessage: null }
    case FETCH_REPORT_SIGNATURE_SUCCESS:
    case SAVE_REPORT_SIGNATURE_SUCCESS:
      return { data: action.data, status: SUCCEEDED, errorMessage: null }
    case DELETE_REPORT_SIGNATURE_SUCCESS:
      return { data: { signature_url: null, adopted_at: null }, status: SUCCEEDED, errorMessage: null }
    case FETCH_REPORT_SIGNATURE_FAILURE:
    case SAVE_REPORT_SIGNATURE_FAILURE:
    case DELETE_REPORT_SIGNATURE_FAILURE:
      return { ...state, status: ERROR, errorMessage: action.errorMessage }
    default:
      return state
  }
}
